var _rect, _line, _line2, _line3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViewOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 5.5,
    width: 12,
    height: 14,
    rx: 1.5,
    stroke: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 9.5,
    y1: 9.5,
    x2: 15.5,
    y2: 9.5,
    stroke: "white",
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 9.5,
    y1: 12.5,
    x2: 15.5,
    y2: 12.5,
    stroke: "white",
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 9.5,
    y1: 15.5,
    x2: 12.5,
    y2: 15.5,
    stroke: "white",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewOrder);
export default __webpack_public_path__ + "static/media/view-order.a37a185a7336722a7c7124c147bb2742.svg";
export { ForwardRef as ReactComponent };